import { Injectable } from "@angular/core";
import { ForecastTemplateMode } from "../interfaces/auto-forecast.interface";
import { PayorMethodology } from "../enums/payor-methodology.enum";

@Injectable({ providedIn: "root" })
export class AutoForecastService {
  private storageKey = "autoForecast";

  private autoForecast = {
    selectedTemplateMode: ForecastTemplateMode.Apply,
    selectedPatientFacilityId: -1,
    selectedPatientId: "",
    selectedFacilityId: "",
    selectedCorporationId: "",
    patientMethodologyId: PayorMethodology.LEVEL,
    patientLastEstDates: {
      PT: null as Date | null,
      OT: null as Date | null,
      ST: null as Date | null,
    },
  };

  constructor() {
    this.loadFromSession();
  }

  /** Load from session storage */
  private loadFromSession() {
    const storedData = sessionStorage.getItem(this.storageKey);
    if (storedData) {
      this.autoForecast = JSON.parse(storedData);
    }
  }

  /** Save to session storage */
  private saveToSession() {
    sessionStorage.setItem(this.storageKey, JSON.stringify(this.autoForecast));
  }

  // ✅ GETTERS
  get selectedTemplateMode(): ForecastTemplateMode {
    return this.autoForecast.selectedTemplateMode;
  }

  get selectedPatientFacilityId(): number {
    return this.autoForecast.selectedPatientFacilityId;
  }

  get selectedPatientId(): string {
    return this.autoForecast.selectedPatientId;
  }

  get selectedFacilityId(): string {
    return this.autoForecast.selectedFacilityId;
  }

  get selectedCorporationId(): string {
    return this.autoForecast.selectedCorporationId;
  }

  get patientMethodologyId(): PayorMethodology {
    return this.autoForecast.patientMethodologyId;
  }

  get patientLastEstDates(): { PT: Date | null; OT: Date | null; ST: Date | null } {
    return this.autoForecast.patientLastEstDates;
  }

  // ✅ SETTERS
  set selectedTemplateMode(mode: ForecastTemplateMode) {
    this.autoForecast.selectedTemplateMode = mode;
    this.saveToSession();
  }

  set selectedPatientFacilityId(id: number) {
    this.autoForecast.selectedPatientFacilityId = id;
    this.saveToSession();
  }

  set selectedPatientId(id: string) {
    this.autoForecast.selectedPatientId = id;
    this.saveToSession();
  }

  set selectedFacilityId(id: string) {
    this.autoForecast.selectedFacilityId = id;
    this.saveToSession();
  }

  set selectedCorporationId(id: string) {
    this.autoForecast.selectedCorporationId = id;
    this.saveToSession();
  }

  set patientMethodologyId(methodology: PayorMethodology) {
    this.autoForecast.patientMethodologyId = methodology;
    this.saveToSession();
  }

  set patientLastEstDates(dates: { PT: Date | null; OT: Date | null; ST: Date | null }) {
    this.autoForecast.patientLastEstDates = dates;
    this.saveToSession();
  }
}
